
        import * as module0 from './controllers/banner_controller.js';import * as module1 from './controllers/blog_card_controller.js';import * as module2 from './controllers/conference_controller.js';import * as module3 from './controllers/contact_controller.js';import * as module4 from './controllers/details_event_controller.js';import * as module5 from './controllers/example_controller.js';import * as module6 from './controllers/height_controller.js';import * as module7 from './controllers/nav_controller.js';import * as module8 from './controllers/scroll_controller.js';import * as module9 from './controllers/top_controller.js'
        const modules = {
            "./controllers/banner_controller.js": module0,
            "./controllers/blog_card_controller.js": module1,
            "./controllers/conference_controller.js": module2,
            "./controllers/contact_controller.js": module3,
            "./controllers/details_event_controller.js": module4,
            "./controllers/example_controller.js": module5,
            "./controllers/height_controller.js": module6,
            "./controllers/nav_controller.js": module7,
            "./controllers/scroll_controller.js": module8,
            "./controllers/top_controller.js": module9,
        };
        export default modules;
      